<template>
  <v-container fluid>
    <v-card>
      <v-toolbar dense flat color="secondary">
        <v-toolbar-title>Sale Return Details</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn small text to="/credit-notes">
          <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-row class="subtitle-2 text--primary">
          <v-col cols="12" md="4">
            <v-simple-table dense>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>Invoice#:</td>
                    <td>{{ Invoice && Invoice.DocNum}}</td>
                  </tr>
                  <tr>
                    <td>Client:</td>
                    <td>{{ Invoice.Customer && Invoice.Customer.Name}}</td>
                  </tr>
                  <tr>
                    <td>Total Bill:</td>
                    <td>{{ Invoice && Invoice.DocTotal | currency}}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>

        <v-divider></v-divider>

        <v-row dense id="po" class="text--primary subtitle-2 mt-2">
          <v-col cols="12">
            <v-data-table
              light
              :mobile-breakpoint="0"
              :items-per-page="pageItems"
              :headers="headers"
              :items="ReturnRows"
              item-key="id"
              hide-default-footer
            >
              <template v-slot:item.Name="{ item }">
                <span style="width: 200px">{{item.product && item.product.Name }}</span>
              </template>

              <template v-slot:item.Quantity="{ item }">
                {{
                item.Quantity
                }}
              </template>

              <template v-slot:item.Price="{ item }">
                <span v-if="item.Price">{{ item.Price | currency }}</span>
              </template>

              <template v-slot:item.DiscSum="{ item }">
                {{
                item.DiscSum
                }}
              </template>

              <template v-slot:item.LineTotal="{ item }">
                {{
                item.LineTotal | currency
                }}
              </template>
            </v-data-table>
          </v-col>
        </v-row>

        <!-- snackbar -->
        <snackbar ref="snackbar"></snackbar>
      </v-card-text>
    </v-card>

    <!-- pdf preview -->
    <pdf-preview ref="pdfPreview"></pdf-preview>
    <!-- end -->
  </v-container>
</template>
  
  
  <script>
export default {
  data: () => ({
    record: {},
    loader: false,
    pageItems: 100,
    Invoice: {},
    ReturnRows: [],
    Payments: [],
    headers: [
      { text: "Product", value: "Name" },
      { text: "Qty", value: "Quantity" },
      { text: "Unit", value: "Unit" },
      { text: "Price", value: "Price" },
      { text: "Total", value: "LineTotal" }
    ]
  }),
  computed: {
    storeName() {
      return localStorage.getItem("storeName");
    }
  },
  watch: {
    "$route.params.id": {
      handler: "getById",
      immediate: true
    }
  },
  methods: {
    getById(val) {
      const self = this;
      // get record
      this.$store
        .dispatch("get", `/sale-return/${val}`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.Invoice = res.ResponseData.Invoice;
            self.ReturnRows = res.ResponseData.ReturnRows;
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    setDate(date) {
      this.record.DocDate = date;
    }
  },
  created() {}
};
</script>
  
  <style  scoped>
/* .v-text-field__details {
    display: none !important;
  } */
</style>